var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-scrollbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && _vm.showMembers.length),expression:"show && showMembers.length"}],ref:"scrollBox",staticClass:"group-member-choose",style:({
    left: _vm.vw - _vm.pos.x < 210 ? _vm.pos.x - 200 : _vm.pos.x + 'px',
    top: _vm.pos.y - 300 + 'px',
  })},_vm._l((_vm.showMembers),function(member,idx){return _c('div',{key:member.id},[_c('chat-group-member',{attrs:{"member":member,"height":40,"active":_vm.activeIdx == idx},nativeOn:{"click":function($event){return _vm.onSelectMember(member)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }